import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import { CircleX, X } from "lucide-react";
import useStickyButton from "../hooks/useStickyButton";

const MultipleReject = ({ progressStates, onRetry, uiConfig }) => {
  const [isMyTenteraFrontFailed, setIsMyTenteraFrontFailed] = useState();
  const [isMyTenteraBackFailed, setIsMyTenteraBackFailed] = useState();
  const [isSelfieFailed, setIsSelfieFailed] = useState();
  const [isHologramFailed, setIsHologramFailed] = useState();
  const { buttonContainerRef, sentinelRef, isSticky, buttonHeight } = useStickyButton();

  // Safe access
  const global = uiConfig?.Global || {};
  const cardBgColor = global?.card?.backgroundColor || "#f3f4f6"; // gray-50
  const textColor = global?.text?.fontColor || "#6b7280"; // default gray-500
  const cardOpacity = global?.card?.opacity || "1"; // default opacity
  const buttonBgColor = global?.button?.backgroundColor || "#2563eb"; // blue-600
  const buttonTextColor = global?.button?.fontColor || "#ffffff"; // white
  const pageBgColor = global?.pageContainer?.backgroundColor || "#ffffff"; // white

  useEffect(() => {
    if (progressStates.myTenteraFront === "Fail") {
      setIsMyTenteraFrontFailed(true);
    }
    if (progressStates.myTenteraBack === "Fail") {
      setIsMyTenteraBackFailed(true);
    }
    if (progressStates.selfieWithMyTentera === "Fail") {
      setIsSelfieFailed(true);
    }
    if (progressStates.hologramDetection === "Fail") {
      setIsHologramFailed(true);
    }
  }, [progressStates]);

  return (
    <div
      style={{
        background: pageBgColor,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: "1rem",
        height: "100%",
      }}
    >
      <div
        style={{
          background: cardBgColor,
          opacity: cardOpacity,
          borderRadius: "0.75rem",
          padding: "1rem",
          marginBottom: "1.5rem",
        }}
      >
        <div className="flex flex-col items-center mb-8">
          <CircleX height="72" width="72" color="red" />
        </div>
        <div className="flex flex-col">
          <p className="text-2xl font-medium">Oops! We couldn't verify your identity</p>
          <p className="text-gray-600 text-md mt-4">
            There are <strong>multiple issues </strong>
            with your MyTentera. Please verify and try again.
          </p>

          <ul className="space-y-2 my-8">
            {isMyTenteraFrontFailed && (
              <li className="flex items-start space-x-2">
                <X className="w-6 h-6 text-red-600" />
                <span>MyTentera front</span>
              </li>
            )}
            {isMyTenteraBackFailed && (
              <li className="flex items-start space-x-2">
                <X className="w-6 h-6 text-red-600" />
                <span>MyTentera back</span>
              </li>
            )}
            {isSelfieFailed && (
              <li className="flex items-start space-x-2">
                <X className="w-6 h-6 text-red-600" />
                <span>Selfie with MyTentera</span>
              </li>
            )}
            {isHologramFailed && (
              <li className="flex items-start space-x-2">
                <X className="w-6 h-6 text-red-600" />
                <span>Hologram detection</span>
              </li>
            )}
          </ul>
          {<ul className="text-gray-600 text-md mt-4"></ul>}
        </div>
      </div>

      <div className="flex flex-1" />

      {/* Sentinel element for Intersection Observer */}
      <div ref={sentinelRef} style={{ height: "1px", visibility: "hidden" }} />

      {/* Spacer to maintain space when button is sticky */}
      {isSticky && buttonHeight > 0 && (
        <div style={{ height: `${buttonHeight}px`, width: "100%" }} />
      )}

      <div 
        ref={buttonContainerRef}
        style={{
          position: isSticky ? "fixed" : "relative",
          bottom: isSticky ? "0" : "auto",
          left: isSticky ? "0" : "auto",
          right: isSticky ? "0" : "auto",
          padding: isSticky ? "1rem" : "0",
          background: "transparent",
          zIndex: isSticky ? "50" : "auto",
          transition: "all 0.3s ease-in-out",
          pointerEvents: isSticky ? "none" : "auto",
        }}
      >
        <button
          style={{
            background: buttonBgColor,
            color: buttonTextColor,
            width: "66.666667%",
            padding: "0.75rem 1rem",
            borderRadius: "9999px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.5rem",
            margin: "0 auto",
            transition: "transform 0.15s ease-in-out",
            pointerEvents: "auto",
          }}
          onClick={onRetry}
          onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
          onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          onTouchStart={(e) => e.currentTarget.style.transform = 'scale(0.95)'}
          onTouchEnd={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <span>Try Again</span>
        </button>
      </div>
      <Footer
        style={{
          fontSize: "0.75rem",
          color: textColor,
          marginTop: "1rem",
        }}
      />
    </div>
  );
};

export default MultipleReject;
